// Recovery stores only public identifiers. A lost POST response is recovered
// with GET, never by silently creating another phone notification.
export const TEST_KEY = 'tutory:inbox-push-test:v1';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const states = ['pending', 'leased', 'accepted', 'unknown', 'failed', 'cancelled', 'expired'];

export function recoverPhoneTest(ownerId) {
  const raw = localStorage.getItem(TEST_KEY);
  if (!raw) return null;
  const value = JSON.parse(raw);
  if (!UUID.test(value?.request_key) || !UUID.test(value?.subscription_id) ||
      !UUID.test(value?.generation) || !Number.isSafeInteger(value?.owner_id)) throw new Error('Invalid test record');
  return value.owner_id === ownerId ? {
    request_key: value.request_key, subscription_id: value.subscription_id,
    generation: value.generation, owner_id: value.owner_id,
  } : null;
}

export function preparePhoneTest(binding, ownerId) {
  if (binding?.owner_id !== ownerId || binding.revoked !== false ||
      !UUID.test(binding.id) || !UUID.test(binding.generation)) throw new Error('Invalid device');
  const record = { request_key: crypto.randomUUID(), subscription_id: binding.id,
    generation: binding.generation, owner_id: ownerId };
  localStorage.setItem(TEST_KEY, JSON.stringify(record));
  return record;
}

export function validatePhoneTest(result, record) {
  if (result?.id !== record.request_key || result.subscription_id !== record.subscription_id ||
      result.generation !== record.generation || !states.includes(result.state) ||
      result.display_confirmed !== false || !Number.isFinite(Date.parse(result.expires_at)))
    throw new Error('Invalid test response');
  return { state: result.state, expires_at: result.expires_at };
}

export function phoneTestDescription(result) {
  return ({
    pending: 'Bandomasis pranešimas eilėje. Galite patikrinti jo būseną.',
    leased: 'Bandomasis pranešimas perduodamas. Galite patikrinti jo būseną.',
    accepted: 'Pranešimų tarnyba priėmė testą. Tai dar nepatvirtina, kad iPhone jį parodė — patikrinkite telefoną.',
    unknown: 'Nežinoma, ar pranešimų tarnyba priėmė testą. Automatiškai nekartosime; patikrinkite telefoną.',
    failed: 'Testo perduoti nepavyko. Patikrinkite telefono registraciją ir serverio konfigūraciją.',
    cancelled: 'Testas atšauktas. Patikrinkite telefono registraciją.',
    expired: 'Testo galiojimas baigėsi. Naują testą galite siųsti atskiru paspaudimu.',
  })[result?.state] || 'Testo rezultatas dar nepatvirtintas. Pirmiausia patikrinkite jo būseną.';
}
